import React, { useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';

import BadgeLabel from '../label/BadgeLabel';
import TimeLabel from '../label/TimeLabel';
import PlayLabel from '../label/PlayLabel';
import NewLabel from '../label/NewLabel';
import { getFormatDate, toPercentTime } from '../../../common/utils/convertUtil';
import { getAppLinkInBox, getMediaAppLink, getAppleStoreLink, isIOS, isAndroid } from '../../../common/utils/appLinkUtil';

export default function Box(props) {
  const router = useRouter();
  const [linkUrl, setLinkUrl] = useState(null);
  const hyperLink = useRef(null);
  const {
    type,
    bottom_type,
    relateId: initialRelateId,
    relateType: initialRelateType,
    srs_div: srsCheck,
    img,
    info,
    label,
    time,
    play,
    link,
    link_url,
    app_link,
    clickParams,
    link_new_yn,
    progress,
    imageQuality,
    isfree,
    content,
    content_num,
    content_date,
    srs_no,
    data,
    isNew,
    current
  } = props;
  const imgUrl = img || 'https://via.placeholder.com/384x216?text=SBS';
  let relateId = initialRelateId;
  let relateType = initialRelateType;
  let boxWrapperName;
  let boxType;

  useEffect(() => {
    if (link?.indexOf('/live/') > -1) {
      const channelId = link.split('/').pop().split('#')[0].split('?')[0];
      setLinkUrl(getAppLinkInBox(channelId, undefined, (link?.indexOf('multiaudio') > -1 ? 'multiaudio_normal' : undefined)));
    } else if (info.media_id) {
      setLinkUrl(getMediaAppLink(app_link || info.media_id, link, relateId));
    }
  }, [link, app_link, info.media_id, relateId]);

  // 박스 타입을 결정하는 함수(퍼블에서 정의한 박스넘버)
  const getBoxType = () => {
    if (type === undefined || type === 'thumb') {
      if (progress) return '1';
      if (props.bold) return '2';
      if (info && info.date) return '3';
      if (info.title && !info.desc) return '4';
      if (info && info.ep && info.date) return '5';
      if (info.title && info.desc) {
        if (info.pgm_title) return '1';
        if (info.pgm_tms_title) return '2';
        return '6';
      }
    }
    return type;
  };
  
  // 박스 타입을 결정하는 함수(퍼블에서 정의한 박스클래스-속성)
  const setBoxProperties = () => {
    const boxType = getBoxType();
    switch (type) {
      case 'poster':
        return { boxWrapperName: 'post_box_w', boxType: 'pb' };
      case 'schedule':
        return { boxWrapperName: 'schedule_box_w', boxType: 'sb' };
      case 'event':
        return { boxWrapperName: 'module_box_w_type8', boxType: 'mb' };
      case 'thumb':
      case 'type':
      default:
        return { boxWrapperName: `module_box_w_type${boxType}`, boxType: 'mb' };
    }
  };

  const setRelateProperties = () => {
    if (bottom_type === 'top_clip' || bottom_type === 'live' || bottom_type === 'new_vod' || bottom_type === 'pnews') {
      return { relateId: bottom_type, relateType: bottom_type };
    }
    return { relateId, relateType };
  };

  const getBoxWrapperName = () => {
    if (relateId != null) {
      switch (relateType) {
        case 'vod':
        case 'curation_vod':
          return srsCheck ? 'module_box_w_type3' : boxWrapperName;
        case 'clip':
        case 'curation_free':
          return 'module_box_w_type4';
        case 'curation_program':
          return 'module_box_w_type6';
        case 'top_clip':
        case 'clip_new':
        case 'pnews':
          return 'module_box_w_type7';
        case 'live':
          return 'module_box_w_type1';
        case 'new_vod':
          return 'module_box_w_type5';
        default:
          return boxWrapperName;
      }
    }
    return boxWrapperName;
  };

  ({ boxWrapperName, boxType } = setBoxProperties());
  ({ relateId, relateType } = setRelateProperties());
  boxWrapperName = getBoxWrapperName();

  const progressbarPercent = (progress?.percent > -1 ? progress.percent : 0) + '%';
  const progressbarStatus = progress?.status || '진행 중';
  const labelObj = { type: boxType, data: label, time, play, free: data?.isfree };

  const onClickLink = () => {
    let link = linkUrl || `${props.link || props.link_url || '#'}`;

    const handleLink = (link) => {
      link_new_yn === 'Y' ? window.open(link) : (window.location = link);
    };

    const handleAppInstallCheck = (callback) => {
      let checkAppInstall = setInterval(() => {
        if (document.hidden) {
          console.log('clear - app installed.');
          clearInterval(checkAppInstall);
          clearTimeout(clickTimer);
        }
      }, 200);
  
      let clickTimer = setTimeout(callback, 3000);
    };
  
    if (isIOS()) {
      if (link.includes('mode=multiaudio')) {
        alert('멀티 오디오 기능은 안드로이드 기기에서만 지원합니다');
        return;
      }

      handleAppInstallCheck(() => {
        if (link.startsWith('sbsplayer://')) {
          window.location = getAppleStoreLink();
        }
      });

      link = divParam(link);
    } else if (isAndroid()) {
      handleAppInstallCheck(() => {
        if (link.startsWith('intent://')) {
          // * 안드로이드는 마켓 URL 알아서 처리
        }
      });

      link = divParam(link, true);
    } else {
      link = divParam(link);
    }

    handleLink(link);
  };

  const divParam = (linkUrl, isAndroid = false) => {
    const originalLink = link || link_url || '#';
  
    if (clickParams) {
      const [key, value] = clickParams.split('=');
      const isNonHttp = isAndroid ? originalLink.indexOf('http') === -1 : !originalLink.startsWith('http');
  
      if (isNonHttp) {
        router.query[key] = value;
  
        let parameter = Object.entries(router.query)
          .filter(([k]) => k !== 'channelID')
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
  
        if (parameter.split('=').length === 2) {
          parameter = parameter.replace('&', '');
        }
  
        parameter = isNativeChecking(value);
  
        linkUrl = `${linkUrl}&${parameter}`;
        
        if (isAndroid) {
          linkUrl += '#Intent;scheme=sbsplayer;package=kr.co.sbs.videoplayer;end';
        }
      } else {
        const httpUrl = new URL(linkUrl);
        httpUrl.searchParams.set(key, value);
        linkUrl = httpUrl.toString();
      }
    }
  
    return linkUrl;
  };

  const isNativeChecking = (parameter) => {
    const isNative = navigator.userAgent.indexOf('SBSApp') > -1;
    const paramMap = {
      main_live: isNative ? 'div=main_live_app' : 'div=main_live',
      live_list: isNative ? 'div=live_list_app' : 'div=live_list',
      live_end: isNative ? 'div=live_end_app' : 'div=live_end'
    };
    return paramMap[parameter] || parameter;
  };

  const renderImage = () => (
    <Image
      src={imgUrl}
      alt={(relateType === 'top_clip' || relateType === 'clip_new')
        ? (props?.title || info?.desc || info?.title || '')
        : (props?.content || info?.desc || info?.title || '')}
      layout='fill'
      style={{ width: '100%', height: '100%' }}
      quality={imageQuality || 50}
    />
  );

  const renderBadgeAndTimeLabels = () => (
    <>
      {['vod', 'curation_vod', 'new_vod'].includes(relateType) && (
        <BadgeLabel {...labelObj} />
      )}
      
      {(relateType !== 'vod' && 
        relateType !== 'curation_vod' && 
        relateType !== 'new_vod' && 
        label.filter(x => x.type === 'bora')) && (
        <BadgeLabel {...labelObj} />
      )}
      
      {(['clip_new', 'top_clip', 'curation_clip', 'clip'].includes(relateType) || 
        (bottom_type === 'live_recommand_clip' && time)) && (
        <TimeLabel text={time} />
      )}
    </>
  );

  const renderInfoContent = () => {
    switch (relateType) {
      case 'vod':
        return (
          <div className='mb_info_w'>
            <span className='mbif_title'>
              {srsCheck === '03' && '스페셜 '}
              {srsCheck === '04' && '파일럿 '}
              {content_num}회 {content}
            </span>
            <span className='mbif_date'>{getFormatDate(content_date)}</span>
          </div>
        );
      case 'curation_vod':
        return (
          <div className={`${boxType}_info_w`}>
            <span className={`${boxType}if_title`}>{info.title}</span>
            <div className='mb_infoline_inner'>
              <span className='mbif_ep'>
                {srsCheck === '03' && '스페셜 '}
                {srsCheck === '04' && '파일럿 '}
                {srs_no}회
              </span>
              <span className='mbif_date'>{getFormatDate(content_date)}</span>
            </div>
          </div>
        );
      case 'new_vod':
        return (
          <div className={`${boxType}_info_w`}>
            <span className={`${boxType}if_title`}>{data.pgm_nm}</span>
            <div className='mb_infoline_inner'>
              <span className='mbif_ep'>
                {srsCheck === '03' && '스페셜 '}
                {srsCheck === '04' && '파일럿 '}
                {data.content_num}회
              </span>
              <span className='mbif_date'>{getFormatDate(data.content_date)}</span>
            </div>
          </div>
        );
      case 'clip':
      case 'clip_new':
      case 'curation_clip':
      case 'curation_program':
      case 'curation_free':
      case 'top_clip':
      case 'live':
      case 'pnews':
        return (
          <div className={`${boxType}_info_w`}>
            {info && info.title && (
              <span className={`${boxType}if_title`}>
                {data?.title || title || info.title}
              </span>
            )}
            {['curation_clip', 'curation_program', 'top_clip', 'live', 'pnews'].includes(relateType) && 
              info && info.title && (
                <span className='mbif_subinfo'>
                  {data?.pgm_nm || info.desc || info.title}
                </span>
              )}
          </div>
        );
      default:
        return (
          <div className={`${boxType}_info_w`}>
            {info && info.title && <span className={`${boxType}if_title`}>{info.title}</span>}
            {info && info.ep && !info.date && <span className={`${boxType}if_ep`}>{info.ep}</span>}
            {info && info.date && !info.ep && <span className={`${boxType}if_date`}>{info.date}</span>}
            {info && info.desc && <span className={`${boxType}if_subinfo`}>{info.desc}</span>}
            {isNew && <NewLabel />}
          </div>
        );
    }
  };

  
  return (
    <>
      {type !== 'schedule' && (
        <div className={boxWrapperName}>
          <a
            target={link_new_yn === 'Y' ? '_blank' : '_self'}
            ref={hyperLink}
            onClick={onClickLink}
            className={`${boxType}_link`}
          >
            <div className={`${boxType}_image_w`}>
              {isfree === 'Y' && relateType === 'tv_free' && (
                <div className='mb_label_w'>
                  <span className='mb_label_partfree' title='부분무료'>
                    부분무료
                  </span>
                </div>
              )}
              <div className={`${boxType}_image_inner`}>
                <div
                  className={`${boxType}_image`}
                  style={{ left: boxType === 'mb' ? '50%' : '', width: '100%' }}
                >
                  {renderImage()}
                </div>
              </div>

              {progress?.percent > -1 && (
                <div className={`${boxType}_progress_w`}>
                  <i className='hide'>라이브 총시간 및 진행시간</i>
                  <span
                    className={`${boxType}_progress`}
                    style={{ width: progressbarPercent }}
                  >
                    <i className='ir'>{progressbarStatus}</i>
                  </span>
                </div>
              )}

              {renderBadgeAndTimeLabels()}
            </div>

            {renderInfoContent()}
          </a>
        </div>
      )}
      {type === 'schedule' && (
        <div
          aria-label={`${info.title}, 방송시간: ${info.desc}`}
          className={`schedule_box_w ${current ? 'current' : ''}`}
        >
          <div className='schedule_box_inner'>
            <div className='schedule_box_title'>
              <p>{info.title}</p>
            </div>
            <div className='schedule_box_time'>{info.desc}</div>

            {progress?.percent > -1 && (
              <div className='schedule_box_progress_w'>
                <i className='hide'>라이브 총시간 및 진행시간</i>
                <span
                  className={`${boxType}_progress`}
                  style={{ width: progressbarPercent }}
                  title={progressbarStatus}
                />
              </div>
            )}

            <div className='round_label_red'>
              <span className='round_ltc_text'>라이브</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}